// utils/sendEmail.js
import axios from "axios";

const backendURL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

export const sendEmail = async (path, formData) => {
  try {
    const response = await axios.post(`${backendURL}/${path}`, formData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
   
    if (response.status !== 200) {
      throw new Error("Failed to send email");
    }

    return response.data;
  } catch (error) {
    console.error("Error sending email:", error);
  } 
};
